import api from '../utils/api'
import { API_ROOT } from '../constants'

export const getTrackedLinks = async (siteDomain, email) => {
  const { data } = await api.get(`${API_ROOT}/v3/site/tracked-links`, { domain: siteDomain, email })
  return data
}

export const createTrackedLink = async (siteDomain, label) => {
  const { data } = await api.post(`${API_ROOT}/v3/site/tracked-links`, { domain: siteDomain, label })
  return data
}

export const deleteTrackedLink = async (siteDomain, label, email) => {
  const { data } = await api.delete(`${API_ROOT}/v3/site/tracked-links`, { domain: siteDomain, label, email })
  return data
}

export const getTrackedLinksAnalytics = async (domain) => {
  try {
    const { data } = await api.get(`${API_ROOT}/v3/site/tracked-links-analytics`, {
      domain: domain.subdomain
    })
    return data
  } catch (error) {
    console.error('Failed to fetch tracked links for analytics:', error)
    throw error
  }
}
